import "./index.scss";
import * as _ from "lodash";
import React, { useState } from "react";
import Dropdown from "../../../../components/core/dropdown";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addProfile } from "../../../../store/profile/thunkAction";
import { useTranslation } from "react-i18next";
import { ScheduleType } from "../../../../constant/enums";
import { getImageUrl } from "../../../../utils/image";
import {
  sendNotifyIziMessageError,
  sendNotifyIziMessageSuccess,
} from "../../../../utils/event";

const AddProfile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const profileManage = useSelector((state) => state.profileManage);
  const isLoadingAddProfile = _.get(
    profileManage,
    "isLoadingAddProfile",
    false
  );

  const [image, setImage] = useState(null);
  const [domain, setDomain] = useState("");
  const [language, setLanguage] = useState("en");
  const [isLiveChat, setIsLiveChat] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [agentName, setAgentName] = useState("");
  const [name, setName] = useState("");
  const [file, setFile] = useState(null);

  const optionsLanguage = [
    { name: t("common.language.vi"), id: "vi" },
    { name: t("common.language.en"), id: "en" },
  ];

  const handleSelectLanguage = (option) => {
    setLanguage(option?.id || "en");
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const validateProfile = () => {
    if (!name && !name.trim()) {
      sendNotifyIziMessageError(t("profile.name_is_require"));
      return false;
    }
    if (!domain && !domain.trim()) {
      sendNotifyIziMessageError(t("profile.domain_is_require"));
      return false;
    }
    if (!/^(?!:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(domain)) {
      sendNotifyIziMessageError(t("profile.domain_invalid"));
      return false;
    }
    return true;
  };

  const saveProfile = async (isContinue = false) => {
    const isOke = validateProfile();
    if (!isOke) {
      return;
    }

    const formData = new FormData();

    formData.append("domain", domain);
    formData.append("language", language);
    formData.append("isLiveChat", isLiveChat);
    formData.append("companyName", companyName);
    formData.append("agentName", agentName);
    formData.append("name", name);
    formData.append("schedule", ScheduleType.ENTIRE_DAY);

    if (file) {
      formData.append("file", file);
    }

    if (isLoadingAddProfile) {
      return;
    }

    try {
      const result = await dispatch(
        addProfile({ data: formData, isFormData: !!file })
      ).unwrap();
      sendNotifyIziMessageSuccess(t("profile.profile_save_success"));
      const profileId = _.get(result, "_id");

      if (isContinue) {
        navigate(`/profile/${profileId}/detail`);

        return;
      }

      navigate(`/izi-message/profile`);
    } catch (error) {
      const errorCode = _.get(error, "errorCode");
      if (errorCode === "FILE_NOT_ALLOWED") {
        sendNotifyIziMessageError(t("profile.upload_file_error"));
      } else if (errorCode === "FILE_TOO_LARGE") {
        sendNotifyIziMessageError(t("profile.file_too_large"));
      } else {
        sendNotifyIziMessageError(t("profile.profile_save_error"));
      }
    }
  };

  return (
    <div className="container">
      <div className="card bg-white border-0">
        <div className="card-body mb-5">
          <div className="row header-title mb-4">
            <div className="col-lg-6">
              <h3 className="color-pri">{t("settings.profile.add_profile")}</h3>
            </div>
            <div className="col-lg-6 text-start text-lg-end align-self-center">
              <a className="default-link" href="#/izi-message/profile">
                <i className="fa fa-arrow-left"></i>{" "}
                {t("settings.manage.profile_manage")}
              </a>
            </div>
          </div>

          <hr className="mb-4 mt-4" />

          <div className="row mb-5">
            <div className="col-lg-3">
              <h5 className="title">{t("settings.profile.general")}</h5>
            </div>
            <div className="col-lg-7">
              <div className="row g-4">
                <div className="col-sm-5">
                  <div className="d-flex gap-4">
                    <img
                      className="avt-image"
                      id="imgAvt"
                      src={getImageUrl(image)}
                      alt=""
                    />
                    <div>
                      <div className="position-relative">
                        <input
                          type="file"
                          id="imgInp"
                          accept="image/*"
                          className="form-control opacity-0"
                          placeholder={t("settings.profile.upload_logo")}
                          onChange={handleImageChange}
                        />
                        <span className="btn btn-info-light w-100 pe-none position-absolute top-0 start-0">
                          <i className="fa fa-upload"></i>{" "}
                          {t("settings.profile.upload_logo")}
                        </span>
                      </div>
                      <div className="mt-4">
                        - {t("settings.profile.logo_desc")}
                        <br />- {t("settings.profile.file_logo_allowed")}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <label className="form-label text-uppercase">
                    {t("settings.profile.name")}
                  </label>
                  <input
                    className="form-control"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className="col-12">
                  <label className="form-label text-uppercase">
                    {t("settings.profile.domain")}
                  </label>
                  <input
                    className="form-control"
                    value={domain}
                    onChange={(e) => setDomain(e.target.value)}
                  />
                </div>
                <div className="col-sm-6">
                  <label className="form-label text-uppercase">
                    {t("settings.profile.language")}
                  </label>
                  <Dropdown
                    config={{
                      options: optionsLanguage,
                      onSelect: handleSelectLanguage,
                      placeholder: "Language",
                      value: language,
                      className: "button-language",
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <label className="form-label text-uppercase">
                    {t("settings.profile.live_chat")}
                  </label>
                  <label className="form-check form-switch gap-2 d-flex align-items-center">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      checked={isLiveChat}
                      onChange={(e) => setIsLiveChat(e.target.checked)}
                    />
                    <span>
                      {isLiveChat ? t("common.enabled") : t("common.disabled")}
                    </span>
                  </label>
                </div>
                <div className="col-12">
                  <label className="form-label text-uppercase">
                    {t("settings.profile.company_name")}
                  </label>
                  <input
                    className="form-control"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                  />
                </div>
                <div className="col-12">
                  <label className="form-label text-uppercase">
                    {t("settings.profile.agent")}
                  </label>
                  <input
                    className="form-control"
                    value={agentName}
                    onChange={(e) => setAgentName(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="d-flex gap-3 justify-content-center align-items-center">
            <button
              onClick={() => saveProfile(true)}
              className="btn btn-primary"
            >
              {t("common.create")} &amp; {t("common.continue_setup")}
            </button>
            <button
              onClick={() => saveProfile()}
              className="btn btn-info-light"
            >
              {t("common.save")} &amp; {t("common.exit")}
            </button>
            <button
              onClick={() => {
                navigate(`/izi-message/profile`);
              }}
              className="btn btn-gray btn-outline-gray"
            >
              {t("common.exit")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddProfile;
